import React from "react";

function Pageinfo({ type, title, message, open, setOpen, close = true }) {
  const color = () => {
    switch (type) {
      case "success":
        return "green";
        break;
      case "error":
        return "rose";
        break;
      case "warning":
        return "yellow";
        break;
      case "info":
        return "blue";
        break;
      default:
        break;
    }
  };

  const Icons = () => {
    switch (type) {
      case "success":
        return (
          <span className="fas fa-check-circle fill-current text-md text-green-500 mt-[2px]"></span>
        );
        break;
      case "error":
        return (
          <span className="fas fa-exclamation-triangle fill-current text-md text-rose-500 mt-[2px]"></span>
        );
        break;
      case "warning":
        return (
          <span className="fas fa-exclamation-triangle fill-current text-md text-yellow-500 mt-[2px]"></span>
        );
        break;
      case "info":
        return (
          <span className="fas fa-info-circle fill-current text-md text-[--bg-color-500] mt-[2px]"></span>
        );
        break;
      default:
        break;
    }
  };
  return (
    <div
      className={`${open ? "block" : "hidden"} ${
        "bg-" + color() + "-100"
      } flex space-x-4 px-4 py-[10px] rounded-md relative text-left`}
    >
      {Icons()}
      <div className="space-y-1">
        <h3 className={`text-[13px] font-bold  ${"text-" + color() + "-500"}`}>
          <b>{title}</b>
        </h3>
        <div
          className={`text-xs font-normal leading-3 tracking-tight text-[#383C43]`}
        >
          <div dangerouslySetInnerHTML={{ __html: message }} />
          {/* <p>{message}</p> */}
        </div>
      </div>
      <div className="absolute right-2 -mt-2">
        {title !== "To Do not Assigned to You" && close && (
          <span
            className={`far fa-times fill-current text-lg float-right cursor-pointer ${
              "text-" + color() + "-800"
            }`}
            onClick={(e) => setOpen(!open)}
          ></span>
        )}
      </div>
    </div>
  );
}

export default Pageinfo;
